'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecipientPlayStats = exports.getRecipientProjects = exports.getRecipientDetailedData = exports.getProjectInfo = exports.getPlayStatsData = exports.getRecipientGlobalData = exports.getDevicesData = exports.getGeographyCitiesData = exports.getGeographyCountriesData = exports.getTracksDetailsData = exports.getRecipientFromList = exports.getCoverageDataRecipient = exports.getCoverageData = exports.getPopularityData = exports.getRecipients = exports.getMyProjects = exports.getPreparedFilteredMyProjects = exports.getAvailableProjects = exports.getStatsViewers = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _reselect = require('reselect');

var _statistics = require('helpers/statistics');

var _projects = require('helpers/projects');

var _recipients = require('helpers/recipients');

var _pagination = require('helpers/pagination');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStatsViewers = function _getStatsViewers(state) {
  return state.statistics.statsViewersData || [];
};
var _getAvailableProjects = function _getAvailableProjects(state) {
  return state.statistics.availableProjectsData || [];
};
var _getProjectsActiveOrder = function _getProjectsActiveOrder(state) {
  return state.statistics.projectsActiveOrder;
};
var _getProjectsOrder = function _getProjectsOrder(state) {
  return state.statistics.projectsOrder;
};
var _getProjectsKw = function _getProjectsKw(state) {
  return state.statistics.projectsKw;
};
var _getRecipients = function _getRecipients(state) {
  return state.statistics.recipientsData;
};
var _getRecipientsActiveOrder = function _getRecipientsActiveOrder(state) {
  return state.statistics.recipientsActiveOrder;
};
var _getRecipientsOrder = function _getRecipientsOrder(state) {
  return state.statistics.recipientsOrder;
};
var _getRecipientsKw = function _getRecipientsKw(state) {
  return state.statistics.recipientsKw;
};
var _getAllMyProjects = function _getAllMyProjects(state) {
  return state.statistics.myProjectsData;
};
var _getPopularityData = function _getPopularityData(state, standalone) {
  return (0, _get3.default)(state.statistics, standalone ? 'popularityStatsData' : ['activityStatsData', 'popularity']);
};
var _getCoverageData = function _getCoverageData(state, standalone) {
  return (0, _get3.default)(state.statistics, standalone ? 'coverageStatsData' : ['activityStatsData', 'coverage']);
};
var _getGeographyData = function _getGeographyData(state, standalone) {
  return (0, _get3.default)(state.statistics, standalone ? 'geographyStatsData' : ['activityStatsData', 'geography']);
};
var _getDevicesData = function _getDevicesData(state, standalone) {
  return (0, _get3.default)(state.statistics, standalone ? 'devicesStatsData' : ['activityStatsData', 'devices']);
};
var _getPlayStatsData = function _getPlayStatsData(state, standalone) {
  return (0, _get3.default)(state.statistics, standalone ? 'playStatsData' : ['activityStatsData', 'playStats']);
};
var _getTracksDetailsData = function _getTracksDetailsData(state) {
  return (0, _get3.default)(state.statistics, 'tracksDetailsStatsData');
};
var _getCoverageRecipientsActiveOrder = function _getCoverageRecipientsActiveOrder(state) {
  return state.statistics.coverageRecipientsActiveOrder;
};
var _getCoverageRecipientsOrder = function _getCoverageRecipientsOrder(state) {
  return state.statistics.coverageRecipientsOrder;
};
var _getProjectInfo = function _getProjectInfo(state) {
  return state.statistics.projectInfoData;
};
var _getRecipientDetailedData = function _getRecipientDetailedData(state) {
  return state.statistics.recipientDetailedStatsData || [];
};
var _getCoverageDataRecipientId = function _getCoverageDataRecipientId(state, recipientId) {
  return recipientId;
};
var _getRecipientsDataRecipientId = function _getRecipientsDataRecipientId(state, recipientId) {
  return recipientId;
};
var _getRecipientGlobalData = function _getRecipientGlobalData(state) {
  return (0, _get3.default)(state.statistics, 'recipientOverallStatsData.generalStats');
};
var _getRecipientProjects = function _getRecipientProjects(state) {
  return (0, _get3.default)(state.statistics, 'recipientOverallStatsData.projects');
};
var _getRecipientProjectsActiveOrder = function _getRecipientProjectsActiveOrder(state) {
  return state.statistics.recipientProjectsActiveOrder;
};
var _getRecipientProjectsOrder = function _getRecipientProjectsOrder(state) {
  return state.statistics.recipientProjectsOrder;
};
var _getMyProjectsListPage = function _getMyProjectsListPage(state) {
  return state.statistics.myProjectsListPage;
};

var getStatsViewers = exports.getStatsViewers = (0, _reselect.createSelector)([_getStatsViewers], function (data) {
  return (0, _statistics.processStatsViewers)(data);
});

var getProcessedAvailableProjects = (0, _reselect.createSelector)([_getAvailableProjects], _projects.processProjects);

var getAvailableProjects = exports.getAvailableProjects = (0, _reselect.createSelector)([getProcessedAvailableProjects, _getProjectsActiveOrder, _getProjectsOrder, _getProjectsKw], function () {
  return _projects.getFilteredProjects.apply(undefined, arguments);
});

var getAllMyProjects = (0, _reselect.createSelector)([_getAllMyProjects], function (projectsByTypes) {
  return [].concat((0, _toConsumableArray3.default)(projectsByTypes[_projects.projectTypes.audio]), (0, _toConsumableArray3.default)(projectsByTypes[_projects.projectTypes.video]));
});

var getPreparedMyProjects = (0, _reselect.createSelector)([getAllMyProjects], _projects.prepareProjects);

var getPreparedFilteredMyProjects = exports.getPreparedFilteredMyProjects = (0, _reselect.createSelector)([getPreparedMyProjects, _getProjectsActiveOrder, _getProjectsOrder, _getProjectsKw], function () {
  return _projects.getFilteredProjects.apply(undefined, arguments);
});

var getMyProjects = exports.getMyProjects = (0, _reselect.createSelector)([getPreparedFilteredMyProjects, _getMyProjectsListPage], function (projects, page) {
  var _getFromTo = (0, _pagination.getFromTo)({ page: page, limit: _statistics.pageLimit }),
      from = _getFromTo.from,
      to = _getFromTo.to;

  var countAll = projects.length;
  return {
    projects: (0, _projects.processProjects)(projects.slice(from, to)),
    countAll: countAll
  };
});

var getRecipients = exports.getRecipients = (0, _reselect.createSelector)([_getRecipients, _getRecipientsActiveOrder, _getRecipientsOrder, _getRecipientsKw], function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var recipients = args[0],
      activeOrder = args[1],
      order = args[2],
      kw = args[3];

  return (0, _recipients.getFilteredRecipients)({ recipients: recipients, activeOrder: activeOrder, order: order, kw: kw });
});

var getPopularityData = exports.getPopularityData = (0, _reselect.createSelector)([_getPopularityData], _statistics.processPopularityData);

var getCoverageData = exports.getCoverageData = (0, _reselect.createSelector)([_getCoverageData, _getCoverageRecipientsActiveOrder, _getCoverageRecipientsOrder], function (data, activeOrder, order) {
  return (0, _statistics.getOrderedCoverageData)({ data: data, activeOrder: activeOrder, order: order });
});

var getCoverageDataRecipient = exports.getCoverageDataRecipient = (0, _reselect.createSelector)([getCoverageData, _getCoverageDataRecipientId], function (data, recipientId) {
  return (0, _find3.default)((0, _get3.default)(data, 'playedRecipients', []), { recipientId: recipientId });
});

var getRecipientFromList = exports.getRecipientFromList = (0, _reselect.createSelector)([_getRecipients, _getRecipientsDataRecipientId], function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var recipientId = arguments[1];
  return (0, _find3.default)((0, _recipients.processRecipients)(data), { id: recipientId });
});

var getTracksDetailsData = exports.getTracksDetailsData = (0, _reselect.createSelector)([_getTracksDetailsData], _statistics.processTracksDetailsData);

var getGeographyCountriesData = exports.getGeographyCountriesData = (0, _reselect.createSelector)([_getGeographyData], _statistics.processGeographyCountriesData);

var getGeographyCitiesData = exports.getGeographyCitiesData = (0, _reselect.createSelector)([_getGeographyData], _statistics.processGeographyCitiesData);

var getDevicesData = exports.getDevicesData = (0, _reselect.createSelector)([_getDevicesData], _statistics.processDevicesData);

var getRecipientGlobalData = exports.getRecipientGlobalData = (0, _reselect.createSelector)([_getRecipientGlobalData], _statistics.processRecipientGlobalData);

var getPlayStatsData = exports.getPlayStatsData = (0, _reselect.createSelector)([_getPlayStatsData], _statistics.processPlayStatsData);

var getProjectInfo = exports.getProjectInfo = (0, _reselect.createSelector)([_getProjectInfo], _statistics.processProjectInfo);

var getRecipientDetailedData = exports.getRecipientDetailedData = (0, _reselect.createSelector)([_getRecipientDetailedData], _statistics.processRecipientDetailedData);

var getRecipientProjects = exports.getRecipientProjects = (0, _reselect.createSelector)([_getRecipientProjects, _getRecipientProjectsActiveOrder, _getRecipientProjectsOrder], function (data, activeOrder, order) {
  return (0, _statistics.processRecipientProjects)({ data: data, activeOrder: activeOrder, order: order });
});

var getRecipientPlayStats = exports.getRecipientPlayStats = (0, _reselect.createSelector)([_getRecipientProjects], function (data) {
  return (0, _statistics.processRecipientProjectsPlayStats)({ data: data });
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/statistics.js
// module id = 126
// module chunks = 1